/* global grecaptcha */

import $ from 'jquery';
import closeModal from './modal';
import successMessage from './templates/commentaire-success.html';
import errorMessage from './templates/commentaire-error.html';

$(document)
.on('submit', '.commentaires form', e => {
    e.preventDefault();
    const $el = $(e.currentTarget);

    if (window.grecaptcha && !window.grecaptcha.getResponse()) {
        $('.g-recaptcha', $el).append('<p class="error-empty">Ce champ est obligatoire</p>');
        return false;
    }

    $.ajax({
        url: $el.attr('action'),
        type: 'POST',
        dataType: 'json',
        data: $el.serialize(),
    })
    .always(resp => {
        const message = resp.status === 200 ? successMessage : errorMessage;
        $('.commentaires form')[0].reset();
        $('.main').prepend(message);
        closeModal();

        if (window.grecaptcha) {
            $('.g-recaptcha', $el).find('.error-empty').remove();
            window.grecaptcha.reset();
        }
    });
});



// WEBPACK FOOTER //
// ./scripts/comments.js